/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The LLM judge's verdict for one in-scope message in the replayed session.
 */
export type PromptGuardrailMessageVerdict = {
  /**
   * Completion tokens billed for this judge call.
   */
  completionTokens: number;
  /**
   * Judge confidence in [0,1]; 0 when not matched.
   */
  confidence: number;
  /**
   * OpenRouter cost for judging this message, in USD. Zero when cost was not returned.
   */
  costUsd: number;
  /**
   * Wall-clock latency for judging this message, in milliseconds.
   */
  latencyMs: number;
  /**
   * True when the guardrail flagged this message.
   */
  matched: boolean;
  /**
   * The chat message ID.
   */
  messageId: string;
  /**
   * The judged message type (user_message, assistant_message, tool_request, tool_response, prompt_attachment).
   */
  messageType: string;
  /**
   * Prompt tokens billed for this judge call.
   */
  promptTokens: number;
  /**
   * One-sentence judge rationale; empty when not matched.
   */
  rationale: string;
  /**
   * Message sequence within the chat generation, ascending.
   */
  seq: number;
  /**
   * Tool name for a single-call tool_request message; empty otherwise.
   */
  toolName?: string | undefined;
  /**
   * Total tokens billed for this judge call.
   */
  totalTokens: number;
};

/** @internal */
export const PromptGuardrailMessageVerdict$inboundSchema: z.ZodMiniType<
  PromptGuardrailMessageVerdict,
  unknown
> = z.pipe(
  z.object({
    completion_tokens: z.int(),
    confidence: z.number(),
    cost_usd: z.number(),
    latency_ms: z.int(),
    matched: z.boolean(),
    message_id: z.string(),
    message_type: z.string(),
    prompt_tokens: z.int(),
    rationale: z.string(),
    seq: z.int(),
    tool_name: z.optional(z.string()),
    total_tokens: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "completion_tokens": "completionTokens",
      "cost_usd": "costUsd",
      "latency_ms": "latencyMs",
      "message_id": "messageId",
      "message_type": "messageType",
      "prompt_tokens": "promptTokens",
      "tool_name": "toolName",
      "total_tokens": "totalTokens",
    });
  }),
);

export function promptGuardrailMessageVerdictFromJSON(
  jsonString: string,
): SafeParseResult<PromptGuardrailMessageVerdict, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PromptGuardrailMessageVerdict$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PromptGuardrailMessageVerdict' from JSON`,
  );
}
